import React from 'react';

import { useGetEvent } from 'legacy/events/hooks';
import MultiTicketsModal from './MultiTicketsModal';
import Loader from 'legacy/common/components/layout/Loader';

type TicketModalProps = {
  onClose: () => void;
  eventId: string;
  showViewEventButton?: boolean;
};

const TicketModalNew: React.FC<TicketModalProps> = ({
  onClose,
  eventId,
  showViewEventButton
}) => {
  const { data: event, isLoading: isLoadingEvent } = useGetEvent(eventId);

  if (isLoadingEvent) {
    return (
      <div className="absolute top-0 left-0 right-0 bottom-0 z-[100]">
        <Loader isOverlay isLoading />
      </div>
    );
  }

  return (
    <MultiTicketsModal
      event={event}
      onClose={onClose}
      showViewEventButton={showViewEventButton}
    />
  );
};

export default TicketModalNew;
